<template>
  <article @click="go()" class="article-preview-container">
    <a :title="name"></a>

    <div class="article-preview-image-container">
      <img class="image-hero" :src="require('@/assets/blog/' + imageName)" />
    </div>

    <div class="article-preview-text-container">
      <header class="article-preview-text">
        <time class="article-date">{{ dateToYMD(createdAt) }}</time>
        <h1 class="article-preview-title">{{ name }}</h1>
        <button class="secondary-button small-button" type="button">
          Read more
        </button>
      </header>
    </div>
  </article>
</template>

<script>
export default {
  props: ["name", "imageName", "createdAt", "path"],

  methods: {
    dateToYMD(date) {
      let strArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let m = strArray[date.getMonth()];
      let y = date.getFullYear();
      return "" + m + " " + y;
    },

    go() {
      this.$router.push({ path: this.path });
    },
  },
};
</script>

<style></style>
